<h1>Standard geometric objects</h1>
<canvas #canvasDocument class="canvas"></canvas>
<div>{{ fps }}</div>
